export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (!navigator.onLine) return false;
  if (error && typeof error === 'object' && 'response' in error) {
    const status = (error as { response?: { status?: number } }).response?.status;
    if (status !== undefined && status >= 400 && status < 500) return false;
  }
  return failureCount < 3;
}
